import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
      // Always run request even though the network is offline
      // https://tanstack.com/query/v4/docs/framework/react/guides/network-mode#network-mode-always
      networkMode: "always",
    },
    mutations: {
      networkMode: "always",
    },
  },
});
